// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__1qpMr","hideOnTablet":"styles_hideOnTablet__V9oUm","hideOnMobile":"styles_hideOnMobile__2CYaX"};